import React from 'react';
import {Form} from 'react-final-form';
import {useIntl} from 'react-intl';

import {useHistory, useLocalesMgr, useSetUI} from 'coreHooks';

import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';
import Typography from 'brandComponents/Typography';

import messages from './messages';
import {SelectCountryForm} from './Subcomponents';

import styles from './ChangeCountry.module.scss';

const ChangeCountry = () => {
	const intl = useIntl();
	const localesMgr = useLocalesMgr();
	const setUI = useSetUI();
	const {managerRepository} = useGeneralProvider();
	const currentLocale = localesMgr.getCurrentLocale();
	const countryCode = currentLocale.getCountryCode();
	const languageCode = currentLocale.getLanguageCode();
	const history = useHistory();

	const handleSubmit = async ({country, language}) => {
		const newSiteId = managerRepository.getCountriesMgr().getCountryByCode(country).getSiteId();

		if (localesMgr.getCurrentCountry().getSiteId() !== newSiteId) {
			setUI.setCountryConfirmRedirectObj({countryCode: country, languageCode: language});

			return managerRepository.getPopupsMgr().openPopup('countryConfirmRedirect');
		}

		await localesMgr.updateLocale(country, language);
		history.push('/');
	};

	return (
		<div className={styles['more-country']}>
			<Typography variant="h3" classNames={styles['more-country__title']}>
				{intl.formatMessage(messages.selectCountry)}
			</Typography>
			<Form
				initialValues={{country: countryCode, language: languageCode}}
				onSubmit={handleSubmit}
				render={(props) => (
					<SelectCountryForm {...props} />
				)}
			/>
		</div>
	);
};

export default ChangeCountry;
